export const USER_DATA_STORAGE = "userDataBC-MR";
export const LAST_PATH = "lastPathBC-MR";
export const MONTH_NAMES = [
  "Janv",
  "Fev",
  "Mars",
  "Avril",
  "Mai",
  "Juin",
  "Juilet",
  "Aout",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];
export const PAGINATION_SIZE = 10;
